import React, { useEffect, useState } from 'react';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import AuthLoader from '../../../components/page_messaging/AuthLoader';
import AuthError from '../../../components/page_messaging/AuthError';
import { employee_dashboard_actions_helper } from '../../../../actions/actions_helper';
import { fail_user_accounts_list, loading_user_accounts_list, reset_user_accounts_list, success_user_accounts_list } from '../../../../reducers/dashboard_reducers/user_accounts/user_accounts_list_Slice';
import { useDispatch } from 'react-redux';
import { EDIT_LOADING_ORDER_ACCESS_DENIED_MSG, EDIT_LOADING_ORDER_ERR_MSG, EDIT_LOADING_ORDER_SUCCESS_MSG, RETRIEVE_ACTIVE_USER_ACCOUNT_LIST_ACCESS_DENIED_MSG, RETRIEVE_ACTIVE_USER_ACCOUNT_LIST_ERR_MSG, RETRIEVE_ACTIVE_USER_ACCOUNT_LIST_SUCCESS_MSG } from '../../../../constants/success_error_messages_consts';
import { EDIT_LOADING_ORDER_API, RETRIEVE_ACTIVE_USER_ACCOUNT_LIST } from '../../../../api/api_data';
import { useSelector } from 'react-redux';
import { messageToast } from '../../../../utils/Utils';
import * as app_consts from "../../../../constants/react_app_consts";
import { Button, Col, Icon, Row, RSelect } from '../../../../components/Component';
import { getSelectedOption, removeWhitespaceAndCapitalize } from '../../../../utils/functionalUtils';
import TextInput from '../../../components/inputs/TextInput';
import ReadOnlyTable from '../table/ReadOnlyTable';
import { fail_create_loading_order, loading_create_loading_order, reset_create_loading_order, success_create_loading_order } from '../../../../reducers/dashboard_reducers/loading_orders/create_loading_order_Slice';

const initialState = { truck_license_plate: "", truck_driver_name: "", transporter_name: "", contact_person: "", driver_instructions: [], consigner_type_id: "", consigner_type: "", trailer_one_no: "", trailer_two_no: "", user_account_id: "", contact_name: "", contact_mobile: "", add_driver_instructions: "", user_account_id: "", loading_order_type: "", loading_order_ref_no: "" };

const buildContactPersonOptionLabel = ({ name = "", phone_number = "", account_label = "" } = {}) =>
  [name || "--", phone_number || "--", account_label || "--"].join(" - ");

const buildContactPersonOption = (data = {}, consignerType) => {
  const name = `${data?.first_name || ""} ${data?.surname || ""}`.trim();
  const account_label =
    consignerType === app_consts.COMPANY_CONSIGNER_STRING
      ? `${data?.unique_identification_number || "--"} - ${data?.company_name || "--"}`
      : `${data?.unique_identification_number || "--"} - ${name || "--"}`;

  return {
    value: `${consignerType}-${data?.unique_identification_number || name || data?.phone_number || "contact"}`,
    user_account_id: data?.unique_identification_number || "",
    consigner_type: consignerType,
    phone_number: data?.phone_number || "",
    name,
    account_label,
    label: buildContactPersonOptionLabel({ name, phone_number: data?.phone_number, account_label }),
  };
};

const EditLoadingOrderDetailsModal = ({ isOpen, cloasModal, successFunction, data }) => {

  const [open, setOpen] = useState(isOpen);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [page_data, setPageData] = useState([]);
  const [received_data, setReceivedData] = useState(data);
  const dispatch = useDispatch();
  const [consigner_list, setConsignerList] = useState([]);
  const [current_consigner_list, setCurrentConsingerList] = useState([]);
  const [company_consigner_list, SetCompanyConsignerList] = useState([]);
  const [customer_consigner_list, SetCustomerConsignerList] = useState([]);
  const [all_contact_person_options, setAllContactPersonOptions] = useState([]);
  const [loading_order_type, setLoadingOrderType] = useState("");
  const [driver_insructions, setDriverInstructions] = useState([]);
  const [formData, setFormData] = useState(initialState);
  const [submit_loading, setSubmitLoading] = useState(false);
  const [submit_error, setSubmitError] = useState("");
  const [selected_table_data, setSelectedTableData] = useState([]);

  useEffect(() => {
    setOpen(isOpen);
    if (data && isOpen)
    {
      setReceivedData(data);
      setLoading(true);
      setFormData({
        ...initialState,
        loading_order_type: data?.loading_order_type?.toLowerCase(),
        consigner_type: data?.consigner_type,
        user_account_id: data?.user_account_id,
        contact_name: data?.contact_person,
        contact_mobile: data?.contact_mobile,
        transporter_name: data?.transporter_name,
        truck_driver_name: data?.truck_driver_name,
        truck_license_plate: data?.truck_license_plate,
        trailer_one_no: data?.trailer_one_no,
        trailer_two_no: data?.trailer_two_no,
        loading_order_ref_no: data?.loading_order_ref_no,
        add_driver_instructions: data?.add_driver_instructions,
      });
      setDriverInstructions(data?.driver_instructions);
      // Fetch Needed Data
      fetchActiveConsigners();
    }
  }, [data, isOpen]);

  const fetchActiveConsigners = () => {
    dispatch(
      employee_dashboard_actions_helper(
        loading_user_accounts_list,
        success_user_accounts_list,
        fail_user_accounts_list,
        RETRIEVE_ACTIVE_USER_ACCOUNT_LIST_ERR_MSG,
        RETRIEVE_ACTIVE_USER_ACCOUNT_LIST_SUCCESS_MSG,
        app_consts.GET,
        RETRIEVE_ACTIVE_USER_ACCOUNT_LIST,
        null,
        RETRIEVE_ACTIVE_USER_ACCOUNT_LIST_ACCESS_DENIED_MSG
      )
    );
  };

  // Listen to State of user_account_list
  const user_accounts_list = useSelector((state) => state.user_accounts_list.user_accounts_list);

  useEffect(() => {
    if (user_accounts_list.status !== app_consts.IDLE)
    {
      if (user_accounts_list.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        setLoading(false);
        if (user_accounts_list.status === app_consts.FAIL)
        {
          messageToast(user_accounts_list.message, app_consts.FAIL);
        } else if (user_accounts_list.status === app_consts.SUCCESS)
        {
          const remapped_company_data = user_accounts_list?.data?.company_accounts?.map((data) => {
            return {
              value: data.unique_identification_number,
              label: `${data.unique_identification_number} - ${data.company_name}`,
              phone_number: data?.phone_number,
              name: `${data.first_name} ${data.surname}`,
              consigner_type: app_consts.COMPANY_CONSIGNER_STRING,
            };
          }) || [];
          setConsignerList(user_accounts_list.data);

          const remapped_customer_data = user_accounts_list?.data?.customer_accounts?.map((data) => {
            return {
              value: data.unique_identification_number,
              label: `${data.unique_identification_number} - ${data.first_name} ${data.surname}`,
              phone_number: data?.phone_number,
              name: `${data.first_name} ${data.surname}`,
              consigner_type: app_consts.CUSTOMER_CONSIGNER_STRING,
            };
          }) || [];
          SetCustomerConsignerList(remapped_customer_data);
          SetCompanyConsignerList(remapped_company_data);
          setAllContactPersonOptions([
            ...(user_accounts_list?.data?.company_accounts?.map((data) =>
              buildContactPersonOption(data, app_consts.COMPANY_CONSIGNER_STRING)
            ) || []),
            ...(user_accounts_list?.data?.customer_accounts?.map((data) =>
              buildContactPersonOption(data, app_consts.CUSTOMER_CONSIGNER_STRING)
            ) || []),
          ]);
        }
        dispatch(reset_user_accounts_list());
      }
    }
  }, [user_accounts_list]);

  const loading_order_type_selection = (typeSelection) => {
    setLoadingOrderType(typeSelection);
    setFormData({ ...formData, ["loading_order_type"]: typeSelection });
  };

  useEffect(() => {
    if (formData?.consigner_type === app_consts.COMPANY_CONSIGNER_STRING)
    {
      setCurrentConsingerList(company_consigner_list);
    }
    else if (formData?.consigner_type === app_consts.CUSTOMER_CONSIGNER_STRING)
    {
      setCurrentConsingerList(customer_consigner_list);
    }
    else
    {
      setCurrentConsingerList([]);
    }
  }, [company_consigner_list, customer_consigner_list, formData?.consigner_type]);

  const handleConsignerSelection = (value) => {
    // Filter Accounts
    if (value === app_consts.COMPANY_CONSIGNER_STRING)
    {
      setCurrentConsingerList(company_consigner_list);
    }
    else if (value === app_consts.CUSTOMER_CONSIGNER_STRING)
    {
      setCurrentConsingerList(customer_consigner_list);
    }
    else
    {
      setCurrentConsingerList([]);
    }
    setFormData((prevState) => ({ ...prevState, consigner_type: value, user_account_id: "", contact_mobile: "", contact_name: "" }));
  };

  const handle_user_account_select = (selectedOption) => {
    const optionValue = selectedOption?.value;
    const filtered_data = current_consigner_list?.find((data) => data?.value === optionValue);

    setFormData((prevState) => ({
      ...prevState,
      user_account_id: optionValue || "",
      contact_mobile: filtered_data?.phone_number || "",
      contact_name: filtered_data?.name || "",
    }));
  };

  const handle_contact_person_select = (selectedOption) => {
    if (!selectedOption)
    {
      setFormData((prevState) => ({ ...prevState, contact_name: "", contact_mobile: "", user_account_id: "" }));
      return;
    }

    if (selectedOption?.consigner_type === app_consts.COMPANY_CONSIGNER_STRING)
    {
      setCurrentConsingerList(company_consigner_list);
    }
    else if (selectedOption?.consigner_type === app_consts.CUSTOMER_CONSIGNER_STRING)
    {
      setCurrentConsingerList(customer_consigner_list);
    }

    setFormData((prevState) => ({
      ...prevState,
      consigner_type: selectedOption?.consigner_type || prevState.consigner_type,
      user_account_id: selectedOption?.user_account_id || "",
      contact_name: selectedOption?.name || "",
      contact_mobile: selectedOption?.phone_number || "",
    }));
  };

  const handleChange = (e) => {
    let change_value = e.target.value;
    if (e.target.name === "truck_license_plate" || e.target.name === "trailer_one_no" || e.target.name === "trailer_two_no")
    {
      change_value = removeWhitespaceAndCapitalize(e.target.value);
    }
    setFormData((prevState) => ({ ...prevState, [e.target.name]: change_value }));
  };

  const getSelectedContactPersonOption = () => {
    if (!formData?.contact_name)
    {
      return null;
    }

    const matchedOption = all_contact_person_options?.find((option) =>
      option?.user_account_id === formData?.user_account_id &&
      option?.name === formData?.contact_name
    );

    if (matchedOption)
    {
      return {
        ...matchedOption,
        label: buildContactPersonOptionLabel({
          name: formData?.contact_name,
          phone_number: formData?.contact_mobile || matchedOption?.phone_number,
          account_label: matchedOption?.account_label,
        }),
      };
    }

    return {
      value: `selected-${formData?.user_account_id || formData?.contact_name}`,
      label: buildContactPersonOptionLabel({
        name: formData?.contact_name,
        phone_number: formData?.contact_mobile,
        account_label: formData?.user_account_id,
      }),
      name: formData?.contact_name,
      phone_number: formData?.contact_mobile,
      user_account_id: formData?.user_account_id,
      consigner_type: formData?.consigner_type,
    };
  };

  // Add Driver Instruction
  const addDriverInstructionFunc = () => {
    if (formData?.add_driver_instructions)
    {
      if (selected_table_data && selected_table_data?.action)
      {
        if (selected_table_data?.action === app_consts.EDIT)
        {
          const instructions = driver_insructions;
          instructions[selected_table_data?.index] = formData?.add_driver_instructions;
          setFormData({ ...formData, ["driver_instructions"]: instructions, ["add_driver_instructions"]: "" });
          setDriverInstructions(instructions);
          messageToast("Driver Instruction Successfully Edited.", app_consts.SUCCESS);
        }
      }
      else
      {
        const instructions = formData?.driver_instructions || [];
        instructions?.push(formData?.add_driver_instructions);
        setFormData({ ...formData, ["driver_instructions"]: instructions, ["add_driver_instructions"]: "" });
        setDriverInstructions(instructions);
        messageToast("Driver Instruction Successfully Added.", app_consts.SUCCESS);
      }
    }
  };

  const edit_loading_order = () => {
    setSubmitError("");
    // Dispatch
    dispatch(
      employee_dashboard_actions_helper(
        loading_create_loading_order,
        success_create_loading_order,
        fail_create_loading_order,
        EDIT_LOADING_ORDER_ERR_MSG,
        EDIT_LOADING_ORDER_SUCCESS_MSG,
        app_consts.POST,
        EDIT_LOADING_ORDER_API,
        formData,
        EDIT_LOADING_ORDER_ACCESS_DENIED_MSG
      )
    );
  };

  // Listen to Create Loading Order Changes
  const create_loading_order_listener = useSelector((state) => state.create_loading_order.create_loading_order);
  // 
  useEffect(() => {
    if (create_loading_order_listener.status !== app_consts.IDLE)
    {
      if (create_loading_order_listener.status === app_consts.LOADING)
      {
        setSubmitError("");
        setSubmitLoading(true);
      } else
      {
        setSubmitLoading(false);
        if (create_loading_order_listener.status === app_consts.FAIL)
        {
          setSubmitError(create_loading_order_listener.message);
          messageToast(create_loading_order_listener.message, app_consts.FAIL);
        } else if (create_loading_order_listener.status === app_consts.SUCCESS)
        {
          messageToast(EDIT_LOADING_ORDER_SUCCESS_MSG, app_consts.SUCCESS);
          successFunction();
          cloasModal();
        }
        dispatch(reset_create_loading_order());
      }
    }
  }, [create_loading_order_listener]);

  // Table Click Listener
  useEffect(() => {
    if (selected_table_data)
    {
      if (selected_table_data?.action === app_consts.EDIT)
      {
        // Edit case
        setFormData({
          ...formData,
          ["add_driver_instructions"]: driver_insructions[selected_table_data?.index]
        });
      } else if (selected_table_data?.action === app_consts.DELETE)
      {
        // Delete case - create a copy first
        const instructions = [...driver_insructions];
        instructions.splice(selected_table_data?.index, 1);

        setDriverInstructions(instructions);
        messageToast("Driver Instruction Successfully Removed.", app_consts.SUCCESS);

        // reset state properly
        setSelectedTableData(null);
      }
    }
  }, [selected_table_data]);




  return (
    <>
      <Modal
        isOpen={open}
        className="modal-dialog-centered"
        size={"xl"}
      >
        <ModalHeader toggle={!loading || !submit_loading ? cloasModal : undefined}>Edit Loading Order Details {received_data?.loading_order_ref_no ? `: ${received_data?.loading_order_ref_no}` : ""}</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <AuthLoader loading_message="Retrieving Loading Order Details..." />
              </>
              :
              <>
                {
                  error && error.length > 0 ?
                    <>
                      <AuthError error_message={error} />
                    </>
                    :
                    <>
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                        }}
                      >
                        <Row className="g-4">
                          <Col size={4}>
                            <div className="form-group">
                              <div className="form-label-group">
                                <label className="form-label text-md" htmlFor="loading_order_type">
                                  Type<span className='text-danger pr-2'>{` *`}</span>
                                </label>
                              </div>
                              <div className="form-control-wrap align-items-center d-flex flex-row justify-between">
                                <div className="w-100">
                                  <RSelect
                                    options={[{ value: app_consts.SINGLE_L0ADING_ORDER_TYPE, label: "Single" }, { value: app_consts.BULK_L0ADING_ORDER_TYPE, label: "Bulk" }]}
                                    className="w-100"
                                    placeholder="Search"
                                    id="loading_order_type"
                                    onChange={(e) => { loading_order_type_selection(e.value); }}
                                    value={getSelectedOption(formData?.loading_order_type, [{ value: app_consts.SINGLE_L0ADING_ORDER_TYPE, label: "Single" }, { value: app_consts.BULK_L0ADING_ORDER_TYPE, label: "Bulk" }])}
                                  />
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col size={4}>
                            <div className="form-group">
                              <div className="form-label-group">
                                <label className="form-label text-md" htmlFor="consigner_type">
                                  Client<span className='text-danger pr-2'>{` *`}</span>
                                </label>
                              </div>
                              <div className="form-control-wrap align-items-center d-flex flex-row justify-between">
                                <div className="w-100">
                                  <RSelect
                                    options={[{ value: app_consts.UAG_CONSIGNER_STRING, label: "UAG" }, { value: app_consts.COMPANY_CONSIGNER_STRING, label: "Company" }, { value: app_consts.CUSTOMER_CONSIGNER_STRING, label: "Individual Customer" }]}
                                    className="w-100"
                                    placeholder="Search"
                                    id="consigner_type"
                                    onChange={(e) => { handleConsignerSelection(e.value); }}
                                    value={getSelectedOption(formData?.consigner_type, [{ value: app_consts.UAG_CONSIGNER_STRING, label: "UAG" }, { value: app_consts.COMPANY_CONSIGNER_STRING, label: "Company" }, { value: app_consts.CUSTOMER_CONSIGNER_STRING, label: "Individual Customer" }])}
                                  />
                                </div>
                              </div>
                            </div>
                          </Col>
                          {
                            (formData?.consigner_type === app_consts.COMPANY_CONSIGNER_STRING || formData?.consigner_type === app_consts.CUSTOMER_CONSIGNER_STRING) && (
                              <>
                                <Col size={4}>
                                  <div className="form-group">
                                    <div className='d-flex justify-between align-items-center'>
                                      <label className="form-label text-md" htmlFor="user_account_id">
                                        Client Details<span className='text-danger pr-2'>{` *`}</span>
                                      </label>
                                    </div>
                                    <div className="form-control-wrap align-items-center d-flex flex-row justify-between">
                                      <div className="w-100">
                                        <RSelect
                                          options={current_consigner_list}
                                          className="w-100"
                                          placeholder="Search"
                                          id="user_account_id"
                                          onChange={handle_user_account_select}
                                          value={getSelectedOption(formData?.user_account_id, current_consigner_list)}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              </>
                            )
                          }
                          <Col size={4}>
                            <div className="form-group">
                              <div className="form-label-group">
                                <label className="form-label text-md" htmlFor="contact_name">
                                  Contact Person<span className='text-danger pr-2'>{` *`}</span>
                                </label>
                              </div>
                              <div className="form-control-wrap align-items-center d-flex flex-row justify-between">
                                <div className="w-100">
                                  <RSelect
                                    options={all_contact_person_options}
                                    className="w-100"
                                    placeholder="Search contact person"
                                    id="contact_name"
                                    onChange={handle_contact_person_select}
                                    value={getSelectedContactPersonOption()}
                                  />
                                </div>
                              </div>
                            </div>
                          </Col>
                          <TextInput
                            colSize={4}
                            label="Contact Person Mobile"
                            type="number"
                            id_val="contact_mobile"
                            value={formData.contact_mobile}
                            handleChange={handleChange}
                            name="contact_mobile"
                            required
                          />
                          {
                            formData?.loading_order_type === app_consts.SINGLE_L0ADING_ORDER_TYPE && (
                              <>
                                <div className="form-label-group">
                                  <label className="form-label text-soft fs-22px">Truck Details</label>
                                </div>
                                <TextInput
                                  colSize={4}
                                  label="Transporter"
                                  type="text"
                                  id_val="transporter_name"
                                  value={formData.transporter_name}
                                  handleChange={handleChange}
                                  name="transporter_name"
                                  required
                                />
                                <TextInput
                                  colSize={4}
                                  label="Truck Driver"
                                  type="text"
                                  id_val="truck_driver_name"
                                  value={formData.truck_driver_name}
                                  handleChange={handleChange}
                                  name="truck_driver_name"
                                  required
                                />
                                <TextInput
                                  colSize={4}
                                  label="Truck Reg No"
                                  type="text"
                                  id_val="truck_license_plate"
                                  value={formData.truck_license_plate}
                                  handleChange={handleChange}
                                  name="truck_license_plate"
                                  required
                                />
                                <TextInput
                                  colSize={4}
                                  label="Trailer Reg 1 (Optional)"
                                  type="text"
                                  id_val="trailer_one_no"
                                  value={formData.trailer_one_no}
                                  handleChange={handleChange}
                                  name="trailer_one_no"
                                />
                                <TextInput
                                  colSize={4}
                                  label="Trailer Reg 2 (Optional)"
                                  type="text"
                                  id_val="trailer_two_no"
                                  value={formData.trailer_two_no}
                                  handleChange={handleChange}
                                  name="trailer_two_no"
                                />
                              </>
                            )
                          }
                          <div className='d-flex flex-row items-center'>
                            <TextInput
                              colSize={8}
                              label="Loading Instructions (Optional)"
                              type="text"
                              id_val="add_driver_instructions"
                              value={formData.add_driver_instructions}
                              handleChange={handleChange}
                              name="add_driver_instructions"
                            />
                            <Col lg="4">
                              <div className="form-group">
                                <div className="form-label-group">
                                  <label className="form-label">
                                    <br />
                                  </label>
                                </div>
                                <div className="form-control-wrap mx-4 d-flex justify-between">
                                  <Button type="button" color="primary" onClick={addDriverInstructionFunc}>
                                    <Icon name={selected_table_data && selected_table_data?.action === app_consts.EDIT ? "pen" : "plus"} />
                                    <span>{selected_table_data && selected_table_data?.action === app_consts.EDIT ? "Edit" : "Add"}</span>
                                  </Button>
                                  {
                                    selected_table_data && selected_table_data?.action === app_consts.EDIT && (
                                      <>
                                        <Button color="light" className="ml-3" onClick={(e) => { e.preventDefault();; setSelectedTableData([]); setFormData({ ...formData, ["add_driver_instructions"]: "" }); }}>
                                          <Icon name="cross" />
                                          <span>Cancel</span>
                                        </Button>
                                      </>
                                    )
                                  }
                                </div>
                              </div>
                            </Col>
                          </div>
                          <div className="form-label-group">
                            <label className="form-label text-soft fs-16px">Loading Instructions</label>
                          </div>
                          {/* Table */}
                          <div className="my-3">
                            <ReadOnlyTable data={driver_insructions} tableType={app_consts.DRIVER_INSTRUCTIONS_TABLE_EDIT} setSelectedData={setSelectedTableData} />
                          </div>
                          {submit_error && (
                            <div className="mb-3">
                              <Alert color="danger" className="alert-icon">
                                {" "}
                                <Icon name="alert-circle" />
                                {submit_error}{" "}
                              </Alert>
                            </div>
                          )}
                          <Col xl="12" className="mb-3">
                            <div className="form-group">
                              <div className="form-control-wrap-flex-wrap justify-end">
                                <Button
                                  onClick={edit_loading_order}
                                  color="primary"
                                  size="lg"
                                  disabled={
                                    submit_loading
                                      ? submit_loading
                                      :
                                      formData?.consigner_type?.toLowerCase() === app_consts.UAG_CONSIGNER_STRING?.toLowerCase() ?
                                        formData?.loading_order_type === app_consts.SINGLE_L0ADING_ORDER_TYPE ? !(formData?.loading_order_type && formData?.contact_name && formData?.contact_mobile && formData?.transporter_name && formData?.truck_driver_name && formData?.truck_license_plate && formData?.loading_order_ref_no) : !(formData?.loading_order_type && formData?.contact_name && formData?.contact_mobile && formData?.loading_order_ref_no)
                                        :
                                        formData?.loading_order_type === app_consts.SINGLE_L0ADING_ORDER_TYPE ? !(formData?.loading_order_type && formData?.contact_name && formData?.contact_mobile && formData?.transporter_name && formData?.truck_driver_name && formData?.truck_license_plate && formData?.user_account_id) : !(formData?.loading_order_type && formData?.contact_name && formData?.contact_mobile && formData?.user_account_id && formData?.loading_order_ref_no)

                                  }
                                >
                                  {submit_loading ? <Spinner size="sm" color="light" /> : "Edit Loading Order"}
                                </Button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </>
                }
              </>
          }

        </ModalBody>
      </Modal>
    </>
  );
};

export default EditLoadingOrderDetailsModal;
